angular.module('impactx.imagezoom', []);